export default __webpack_public_path__ + "static/media/desc-services-image-01.7cbbc490.png";